/**
 * Node Modules
 */
import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet'
import 'modern-normalize'

/**
 * Application Modules
 */
import './style.css'
import '../styles/tokens.css'
import '../styles/typography.css'
import '../styles/layout.css'
import '../styles/helpers.css'
import windowWidth from '../../helpers/window-width'

function handleResize(e) {
  if (typeof document !== 'undefined') {
    document.documentElement.style.setProperty('--window-width', windowWidth())
    document.documentElement.style.setProperty('--window-height', windowWidth())
  }
}

handleResize()

function handleLiveChatCustomize() {
  if (typeof document !== 'undefined') {
    setTimeout(() => {
      if (!!document.querySelector('#launcher')) {
        try {
          const $zenchat = document.querySelector('#launcher').contentDocument;
          $zenchat.querySelector('button').style.boxShadow = 'inset 0px 0px 0px 3px rgba(255,255,255,0.3)';
        } catch (e) { }
      } else {
        handleLiveChatCustomize();
      }
    }, 300);
  }
}

handleLiveChatCustomize();


/**
 * Component
 */
export default function PageContainer(props) {
  // Props
  const { children } = props

  // Hooks
  const element = useRef(null)

  // Handlers
  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Component
  return (
    <div ref={element}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kinzoo | A Messaging App For Families</title>

        <link rel="preconnect" href="https://kinzoo.com" />
        <link rel="preconnect" href="https://marketingplatform.google.com" />
        <link rel="preconnect" href="https://www.google.com" />

        <link rel="prefetch" href="/fonts/Radial-Regular.woff2" />
        <link rel="prefetch" href="/fonts/Radial-Bold.woff2" />
        <link rel="prefetch" href="/fonts/Radial-Semibold.woff2" />

        <meta
          name="description"
          property="og:description"
          content="Kinzoo is a messaging app that turns screen time into family time."
        ></meta>
        <link rel="shortcut icon" href="/favicon.png"></link>
        <meta property="og:type" content="website"></meta>
        <meta property="og:title" content="Kinzoo | A Messaging App For Families" />
        <meta property="og:type" content="article" />
        <meta
          name="image"
          property="og:image"
          content="https://kinzoo.com/Kinzoo_website_thumbnail-2.jpg"
        />
        <meta name="twitter:site" content="@kinzoomessenger" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@kinzoomessenger" />
        <meta name="twitter:title" content="Kinzoo | A Messaging App For Families" />
        <meta
          name="twitter:description"
          content="Kinzoo is a messaging app that turns screen time into family time."
        />
        <meta name="twitter:image" content="https://kinzoo.com/Kinzoo_website_thumbnail-2.jpg" />
      </Helmet>
      {children}
    </div>
  )
}
